import { wrap as withStyle, themeColor } from 'utils/styles'
import Icon from 'components/patterns/Icon'
import styled from '@emotion/styled'

export default withStyle(() => {
  return `
    &&.ant-collapse > .ant-collapse-item > .ant-collapse-header {
      padding-left: 16px !important;
    }
    &&.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
      left: 9px;
    }
  `
})

export const StyledIcon = styled(Icon)`
  width: 15px;
  height: 15px;
  vertical-align: top;
  font-size: 13px;
  margin-top: -1em;
  color: ${themeColor('alertButtonHoverColor')};
  pointer-events: visible;
`
